import { Checkbox } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import articleDeliveryTypes from "astrid-firestore/src/api/articles/constants/articleDeliveryTypes";
import { getArticlesAutoDeliverySettings } from "astrid-firestore/src/api/distribution/getArticleAutoDeliverySettings";

import FlexColumn from "../../../../../components/Flex/FlexColumn";
import Form from "../../../../forms/components/Form/Form";
import Popup from "../../../../ui/components/Popup/Popup";

export default function useDistributeArticlesChannelsTableColumns({ form, articles, channels }) {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			Header: t("channel", "Channel"),
		},
		deliveryColumn({
			t,
			form,
			articles,
			channels,
			deliveryType: articleDeliveryTypes.METADATA,
			Header: t("meta", "Meta"),
		}),
		deliveryColumn({
			t,
			form,
			articles,
			channels,
			deliveryType: articleDeliveryTypes.ARTIFACT,
			Header: t("files", "Files"),
		}),
	];
}

function deliveryColumn({ t, form, channels, articles, deliveryType, Header }) {
	return {
		id: deliveryType,
		Header: (
			<FlexColumn style={{ alignItems: "center", gap: 5 }}>
				{Header}
				{channels?.length > 1 && (
					<Checkbox
						slider
						defaultChecked={Object.values(form.getValues("delivery")).some(
							(delivery) => delivery[deliveryType],
						)}
						onClick={(_, { checked }) => {
							for (const channel of channels) {
								const { id } = channel;

								const delivery = form.getValues(`delivery.${id}`);

								form.setValue(
									`delivery.${id}`,
									getArticlesAutoDeliverySettings({
										channel,
										articles,
										overrides: {
											...delivery,
											[deliveryType]: checked,
										},
									}),
									{ shouldValidate: true },
								);
							}
						}}
					/>
				)}
			</FlexColumn>
		),
		textAlign: "center",
		Cell: ({ row: channel }) => {
			const { id, disableArtifactDeliveryWithoutMetadata, forceDeliveryOfMetadataAndFilesSimultaneously } =
				channel;

			const metadataRequired = !!disableArtifactDeliveryWithoutMetadata;

			const bothRequired = forceDeliveryOfMetadataAndFilesSimultaneously;

			const { metadata: metadataDeliveryPossible, artifact: artifactDeliveryPossible } =
				getArticlesAutoDeliverySettings({
					channel,
					articles,
					overrides: {
						metadata: true,
						artifact: true,
					},
				});

			const showMandatoryPopup = bothRequired || (deliveryType === "metadata" && metadataRequired);

			return (
				<Popup
					content={t("mandatory", "Mandatory")}
					disabled={!showMandatoryPopup}
					trigger={
						<Form.Checkbox
							name={`delivery.${id}.${deliveryType}`}
							slider
							onChange={(_, { checked }) => {
								const delivery = form.getValues(`delivery.${id}`);

								form.setValue(
									`delivery.${id}`,
									getArticlesAutoDeliverySettings({
										channel,
										articles,
										overrides: {
											...delivery,
											[deliveryType]: checked,
										},
									}),
									{ shouldValidate: true },
								);
							}}
							disabled={
								!(
									(deliveryType === articleDeliveryTypes.METADATA && metadataDeliveryPossible) ||
									(deliveryType === articleDeliveryTypes.ARTIFACT && artifactDeliveryPossible)
								)
							}
						/>
					}
				/>
			);
		},
	};
}
